"use client";
export { Strong as default } from "../../../_Builtin/Typography";
